require([
	'jquery',
	'base/MbiHelper',
	'base/MbiImageSize',
	'root/Assets/Js/Vendor/blazy',
	'root/Base/Js/Vendor/PictureFill',
	'root/Assets/Js/Projects',
	'root/Assets/Js/Templates'
], function($,_,mbiImageSize,Blazy) {
	'use strict';
	// ----------------------------------------------------------------
	// IMAGE COVER FIX
	// ----------------------------------------------------------------
	var bLazy = new Blazy({
		selector: '.blazy-image',
		src: 'data-srcset'
	});

	$('picture img.js_image-cover').load(function() {
		mbiImageSize.checker($(this));
	});

	setTimeout(function(){
		mbiImageSize.init();
	},100);


	function browserRatioCheck() {
		var width = $(window).width(),
			height = $(window).height();

		if ((width / height) <= 1.25) {
			$('body:not(.portrait)').addClass('portrait');
		} else {
			$('body').removeClass('portrait');
		}
	}

	if (_.exists('.loading-screen')) {
		browserRatioCheck();
		$(window).on('resize', function(){
			browserRatioCheck();

		});
	}

	$(document).on('click', '.js_loadmain', function(){
		$('body').addClass('started');
	});

	$(document).on('click', '.footer .footer__right .menu__item--last a', function(e){
		e.preventDefault();
		var href =  $(this).attr('href'),
			$this = $(this);
		if (!$this.hasClass('loaded')) {
			var data = {
				'action': 'load_ankauf'
			};

			$.ajax({
				dataType: 'json',
				url: href,
				data: data,
				timeout: 10000,
				error: function(){console.log('error');},
				success: function(response){

					$('body').append(response.html);
					$this.addClass('loaded');
					$('body').addClass('popup-open');
				}

			});

		} else {
			$('body:not(.popup-open)').addClass('popup-open');
		}
	});
	$(document).on('click', '.js_popup-close', function(){
		$('body').removeClass('popup-open');
	});
});
define("Assets/Js/Footer.js", function(){});

